import { ProjectSelectors } from "@app/project/store";
import { initialCommandState } from "@app/project/store/clarehome.state";
import { CommandProviders } from "@app/rule/model/commands/command";
import { isSceneCommand, SceneCommand } from "@app/rule/model/commands/scene-command";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CHCommandState } from "../rule.state";

const selectCommandState = createFeatureSelector<CHCommandState>("chscenecommand");

export const selectCommandsState = createSelector(selectCommandState, ProjectSelectors.getUuid, (state: CHCommandState, uuid: string) =>
    state?.uuid ? state : initialCommandState(uuid)
);

const sortDealerScenes = (scenes: any[]) =>
    Object.values(scenes)
        .filter(command => !command.createdByMch)
        .sort((a, b) => a.name.localeCompare(b.name));

export const selectDealerSceneCommandsState = createSelector(selectCommandsState, resultState => {
    if (resultState.result) {
        const commandsObject = Object.values(resultState.result);
        const sceneCommands = commandsObject.filter((command: any) => command.commandType === CommandProviders.SCENE);
        return {
            result: sortDealerScenes(sceneCommands),
            uuid: resultState.uuid,
            callState: resultState.callState,
        };
    }
    return resultState;
});

export const selectCommand = (commandId: string) =>
    createSelector(selectCommandsState, commandState => {
        const commandForId = commandState?.result?.[commandId] ? Object.assign({}, commandState?.result?.[commandId]) : null;
        if (isSceneCommand(commandForId)) {
            const newSteps = {};
            let index = 0;
            Object.values(commandForId.steps).forEach(step => {
                newSteps[index] = {
                    action: commandState.result[step.action.command_id],
                    delay: step.delay,
                };
                index++;
            });
            commandForId.steps = newSteps;
        }
        return {
            uuid: commandState.uuid,
            callState: commandState.callState,
            result: commandForId,
        };
    });

export const loadingCommandState = createSelector(selectCommandsState, resultState => resultState.callState);

export const selectScenes = createSelector(selectCommandsState, (resultState): SceneCommand[] => {
    if (resultState?.result) {
        const commandsObject = Object.values(resultState.result);
        return commandsObject.filter(command => isSceneCommand(command)) as SceneCommand[];
    }
    return [];
});
